import { render } from "./Pagination.vue?vue&type=template&id=69946837"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=69946837&lang=scss"
script.render = render

export default script